import { LinearProgress, Stack } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import { UserContext } from "../../../../contexts/UserProvider";
import PaperSection from "../../../display/PaperSection";
import UserSelector from "../../../form/UserSelector";
import { BookingContext } from "../context/BookingModalContext";
import useGetAppointmentObject from "../utils/useGetAppointmentObject";
import SharedBookingModalForm from "./SharedBookingModalForm";
import SimpleAlert from "../../../display/SimpleAlert";
import dayjs from "dayjs";
import usePetViewRoute from "../../../../features/pets/hooks/usePetViewRoute";

export default function AdminBooking() {
  const data = React.useContext(BookingContext);
  const { getAutoCompleteUsers } = React.useContext(UserContext);
  const { getObject } = useGetAppointmentObject();
  const methods = useFormContext();
  const { isPetView, ownerId: userId } = usePetViewRoute();

  function submittingData(e) {
    var submitObject = getObject(e);
    if (submitObject?.pet == "") {
      delete submitObject?.pet;
    }
    submitObject.confirmedAt = dayjs().format("DD/MM/YYYY, HH:mm:ss");
    data.submitData(submitObject);
  }

  React.useEffect(() => {
    if (isPetView && userId) {
      methods.setValue(
        "user",
        getAutoCompleteUsers().find(
          (user) => Number(user?.id) == Number(userId)
        )
      );
    }
  }, []);

  const permission = true;

  return (
    <form onSubmit={methods.handleSubmit(submittingData)}>
      <Stack mb={4}>
        {permission ? (
          <PaperSection>
            <UserSelectorView data={data} />
          </PaperSection>
        ) : null}
      </Stack>
      <SharedBookingModalForm />
    </form>
  );
}

export function UserSelectorView({ data, showNewUserForm = true}) {
  const {
    getAutoCompleteUsers,
    isLoading: userLoading,
    error: errorFetchingUsers,
  } = React.useContext(UserContext);

  if (userLoading) {
    return <LinearProgress />;
  } else if (errorFetchingUsers && !userLoading) {
    return (
      <SimpleAlert
        message={"ErrorFetchingUsers"}
        severity={"error"}
        testId={"appointment.booking-form.user-error-alert"}
      />
    );
  }

  return (
    <UserSelector
      toggleNewUserSelected={data.toggleNewUserSelected}
      isNewUserSelected={data.isNewUserSelected}
      label={"SelectUser"}
      users={getAutoCompleteUsers()}
      showNewUserForm={showNewUserForm}
      testId={"appointment.booking-form.user-select"}
    />
  );
}
